import { render, staticRenderFns } from "./plattaskwaitaccept.vue?vue&type=template&id=2208d39d&scoped=true&"
import script from "./plattaskwaitaccept.vue?vue&type=script&lang=js&"
export * from "./plattaskwaitaccept.vue?vue&type=script&lang=js&"
import style0 from "./plattaskwaitaccept.vue?vue&type=style&index=0&id=2208d39d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2208d39d",
  null
  
)

export default component.exports